import React from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';

import { useAuth } from '../../auth/useAuth';
import Breadcrumbs from '../../layouts/components/Breadcrumbs';
import Header from '../../layouts/components/Header';

const Login: React.FC = () => {
  const { isLoading, login } = useAuth();
  const location = useLocation();

  const from = (location.state as { from?: string })?.from || '/';

  const handleLogin = async () => {
    await login(from);
  };

  return (
    <>
      <Box component="section" className="mainLayoutBox">
        <Header isQuestionnaire={false} />
        <Breadcrumbs />
        <main>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              height: 'calc(100vh - 72px)',
              justifyContent: 'center',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 400,
                p: 4,
                textAlign: 'center',
                width: '100%',
              }}
            >
              <Typography variant="body1" color="text.secondary" gutterBottom>
                Sign in to access medical policies
              </Typography>
              <Button
                variant="contained"
                onClick={handleLogin}
                disabled={isLoading}
                size="large"
                fullWidth
                sx={{ mt: 3 }}
              >
                {isLoading ? 'Redirecting...' : 'Sign in with SSO'}
              </Button>
            </Box>
          </Box>
        </main>
      </Box>
    </>
  );
};

export default Login;
